import CalendarIcon from '@/components/icons/calendar';
import StyledSelect from '@/components/common/styledSelect';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { Stack, Typography } from '@mui/material';

const selectOptions = [{ value: '3', label: 'Last 3 Months' }];
const checkOptions = [{ value: 'all', label: 'All account numbers' }];

const AdvisorTableHeader = ({ tab }: { tab?: string }) => {
  return (
    <Stack direction='row'>
      <Stack
        direction='row'
        flex={1}
        gap={1}
        alignItems='center'
      >
        <Typography variant='h6'>Recently Uploaded</Typography>
        <ArrowDropDown />
      </Stack>

      {tab === 'statements' && (
        <StyledSelect
          options={checkOptions}
          value='all'
          onChange={() => {}}
          sx={{ mr: 2 }}
        />
      )}
      <StyledSelect
        startAdornment={<CalendarIcon />}
        options={selectOptions}
        value='3'
        onChange={() => {}}
      />
    </Stack>
  );
};

export default AdvisorTableHeader;
